<template>
  <sc-render :fields="fields" :empty-message="$t('NO_DATA_SOURCE_EXIST')">
    <div :class="['double-image', { 'theme-dark': isDarkTheme }]">
      <div class="images-container">
        <media-display
          aspect-ratio="3/4"
          :sc-image-field="firstImage"
          :image-desktop-source="firstImageSrc"
          :fraction="fraction"
        />
        <media-display
          aspect-ratio="3/4"
          :sc-image-field="secondImage"
          :image-desktop-source="secondImageSrc"
          :fraction="fraction"
        />
      </div>
      <sc-text class="tag" tag="p" :field="tag || {}" />
    </div>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text, Image } from '@sitecore-jss/sitecore-jss-vue'
import mapFields from '~/helpers/map-fields'
import ScRender from '~/components/sitecore/sc-render'
import MediaDisplay from '~/components/sitecore/media-display'
import fraction from '~/constants/fraction'
import ThemeMixin from '~/mixins/theme'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'EditorialDoubleImage',

  components: {
    MediaDisplay,
    ScImage: Image,
    ScText: Text,
    ScRender
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  mixins: [ThemeMixin],

  computed: {
    ...mapJssGetters(['isEditMode']),

    ...mapFields({
      firstImage: 'firstImage',
      firstImageSrc: 'firstImage.value.src',
      secondImage: 'secondImage',
      secondImageSrc: 'secondImage.value.src',
      tag: 'tag'
    }),

    fraction () {
      return fraction.twoFr // see styles for fraction
    }
  }
}
</script>

<style lang="scss" scoped>
.double-image {
  padding: 0 $space-050;
  @include stack-space($space-090);

  @include tablet {
    @include reset;
    width: 70%;
    margin: 0 auto;
    @include stack-space($space-110);
  }

  .images-container {
    display: grid;
    grid-gap: $space-050;
    @include stack-space($space-040);

    @include tablet {
      grid-template-columns: 1fr 1fr; //see computed fraction
    }
  }

  .tag {
    @include font('040');
    color: $color-slate-gray;
    padding-right: $space-060;

    @include tablet {
      padding-right: $space-080;
    }
  }

  &.theme-dark {
    .tag {
      color: $color-cream;
    }
  }
}
</style>
